import { Paper } from '@mui/material';
import React, { ReactNode, useMemo } from 'react';
import { withDroppable } from '@/components/droppable/withDroppable';
import { useTheme, Theme } from '@mui/material/styles';

interface IProps {
  classNames?: any;
  children: ReactNode | ReactNode[];
}

const useStyles = (theme: Theme) => ({
  container: {
    border: 0,
    backgroundColor: theme.palette.grey[200],
    borderRadius: 4,
    '&:last-child': {
      marginBottom: 0,
    },
  },
});

const Container = React.memo(({ children, ...props }: IProps) => {
  const theme = useTheme();
  const classes = useMemo(() => useStyles(theme), [theme]);

  return (
    <Paper sx={classes.container} {...props}>
      {children}
    </Paper>
  );
});

export const NodeContainer = withDroppable(Container);
